const exactNames = {
  '花瓣入水拓': 'Petal Water Imprint',
  '祖鮭心跳記錄': 'Ancestral Salmon Heartbeat Record',
  '迴游羅盤': 'Migration Compass',
  '鰤王之顎': 'Jaw of the Buri King',
  '銀龍捲核心': 'Silver Vortex Core',
  '境界之膜': 'Membrane of the Boundary',
  '赤鳥居御守': 'Red Torii Talisman',
  '鯨骨橋鑰匙': 'Whale-Bone Bridge Key',
  '玉澄共鳴': 'Tamasumi Resonance',
  '中間之眼': 'Eye of the Middle',
  '王鮪紅眼': 'Crimson Eye of the Tuna King',
  '絕對暗': 'Absolute Darkness',
  '黑鳥居御守': 'Black Torii Talisman',
  '千刀墓碑': 'Monument of a Thousand Blades',
  '醬油瀑布源頭': 'Source of the Soy Waterfall',
  '無主的壽司魂': 'Masterless Sushi Soul',
  '初代問答': 'The First Chef Question',
  '空': 'Emptiness',
  '最古刀痕': 'Oldest Knife Mark',
  '金色注連繩': 'Golden Shimenawa',
  '始祖鮭神燃鱗': 'Burning Scale of the Primordial Salmon God',
  '神代逆流之水': 'Divine-Age Upstream Water',
  '天黃世界膜': 'Tenkō World Membrane',
  '守火神溫': 'Divine Warmth of the Keeper Flame',
  '櫻躍時間殼': 'Sakura-Leap Time Shell',
  '慢時觸鬚': 'Slow-Time Antenna',
  '無星宇宙墨': 'Starless Cosmic Ink',
  '墨眷透明骨': 'Transparent Bone of the Ink Familiar',
  '金爆神棘': 'Golden-Burst Divine Spine',
  '超新星海膽核': 'Supernova Uni Core',
  '銀河神鯖圖': 'Chart of the Divine Mackerel Galaxy',
  '永洄軌道鱗': 'Eternal-Orbit Scale',
  '天衡神眼淚晶': 'Tear Crystal of the Judging Eye',
  '御前赤身血珠': 'Akami Guard Blood Pearl',
  '百層鯨神歌骨': 'Hundred-Layer Whale-Song Bone',
  '神歌水紋': 'Divine-Song Ripple',
  '眾旬神審判票': 'Judgment of the Shun Gods',
  '百旬神使之羽鱗': 'Feather Scale of the Hundred-Season Envoy',
  '一期一會原生旬味': 'Once-in-a-Lifetime Origin Flavor',
  '源心味噌脈': 'Source-Heart Miso Vein',
  '百年未言之心': 'Century-Old Unspoken Heart',
  '晨光魚鱗': 'Morning-Light Fish Scale',
  '洄游水珠': 'Migration Water Pearl',
  '桶緣潮鹽': 'Oke-Rim Tide Salt',
  '深壓魚骨': 'Pressure-Forged Fish Bone',
  '磷光黏液': 'Bioluminescent Trace',
  '沉水黑砂': 'Sunken Black Sand',
  '記憶魚鱗': 'Memory Fish Scale',
  '古木沉屑': 'Ancient-Wood Sediment',
  '失傳味塵': 'Lost-Flavor Dust',
  '神域光塵': 'Sacred-Domain Light Dust',
  '始祖氣息': 'Primordial Breath',
  '無重力水晶': 'Weightless Crystal',
  '旬魚側線鱗': 'Seasonal Fish Lateral Scale',
  '逆流紅鱗': 'Upstream Crimson Scale',
  '高速魚腱': 'High-Speed Fish Tendon',
  '青銀油膜': 'Blue-Silver Oil Sheen',
  '群游共鳴鱗': 'School Resonance Scale',
  '水切胸鰭': 'Current-Cutting Pectoral Fin',
  '桶隙黏膜': 'Oke-Crevice Membrane',
  '活性墨囊': 'Living Ink Sac',
  '擬態吸盤': 'Mimetic Sucker',
  '鏽甲碎片': 'Rustshell Fragment',
  '深棘核心': 'Deep-Spine Core',
  '磷光傘膜': 'Phosphorescent Bell Membrane',
  '潮音珠': 'Tide-Song Pearl',
  '幽燈囊': 'Ghost-Lantern Sac',
  '低鳴骨片': 'Low-Song Bone Fragment',
  '記憶殘響': 'Memory Echo',
  '偷鮮鬍鬚': 'Freshness-Seeking Whisker'
};

const exactNotes = {
  '此層主要旬味留下的完整樣本':
    'A complete specimen left by the primary seasonal ingredient of this floor.',
  '安全層平靜水域凝結的透明樣本':
    'A clear specimen condensed from the calm water of this safe floor.',
  '櫻花掉進桶的瞬間':
    'The instant a cherry blossom touched the water.',
  '呼應九十一層鮭神':
    'Resonates with the Salmon God on Floor 91.',
  '記錄淺層魚群遷移路線':
    'Records the migration routes of the shallow-water schools.',
  '鰤王試練留下的核心部位':
    'A vital remnant left by the trial of the Buri King.',
  '萬尾鯵群形成的渦心':
    'The heart of a vortex formed by ten thousand aji.',
  '晨光與深淵的分界':
    'The boundary between morning light and the Abyss.',
  '問診之間的安全層護符':
    'A safe-floor talisman from the Diagnosis Chamber.',
  '守火之間的安全層護符':
    'A safe-floor talisman from the Keeper-Flame Chamber.',
  '無心之間的最終守護':
    'The final ward of the Chamber of No-Mind.',
  '凝視上下兩界的塔心之眼':
    'The tower eye that watches the realms above and below.',
  '深海王鮪用以辨認獵物的紅眼':
    'The crimson eye used by the Tuna King to identify prey.',
  '無光之底凝結的黑暗本身':
    'Darkness itself, condensed at the lightless bottom.',
  '無名板前舊刀匯聚的墓碑':
    'A monument formed from the old blades of nameless itamae.',
  '仍在流動的百年古醬油':
    'Century-old soy sauce that continues to flow.',
  '尋找原來客人的完成品':
    'A finished offering still searching for its original guest.',
  '忘卻板長留下的唯一提問':
    'The only question left by the Forgotten Head Chef.',
  '空桶內放大的無形回聲':
    'An invisible echo amplified inside an empty oke.',
  '神明落下的世界第一道刀痕':
    'The first knife mark in the world, made by a god.'
};

const tierNames = {
  1: 'EARTH',
  2: 'RUST',
  3: 'MOON WHITE · R',
  4: 'GOLDEN TEA · SR',
  5: 'VERMILION GOLD · SSR',
  6: 'INK RAINBOW · EX'
};

function englishIngredientSpecimen(floor) {
  return `${floor.name_en} Seasonal Specimen`;
}

function englishCreatureProof(name) {
  return `${name} Relic`;
}

export function getEnglishTier(tier) {
  return tierNames[tier] || 'ARCHIVED';
}

export function translateSpecimen(item, floor, creatureName = '') {
  let name = exactNames[item.name];

  if (!name && item.name.endsWith('標本')) {
    name = englishIngredientSpecimen(floor);
  }

  if (!name && item.name.endsWith('安息水')) {
    name = `${floor.name_en} Resting Water`;
  }

  if (!name && item.name.endsWith('之證')) {
    name = englishCreatureProof(creatureName || floor.name_en);
  }

  const note = exactNotes[item.note]
    || (item.note?.includes('神性殘片')
      ? 'A divine fragment left when the floor guardian manifested.'
      : item.note?.includes('來源：')
        ? 'A recoverable trace left by one of this floor’s creatures.'
        : 'A recoverable memory preserved within this floor.');

  return {name: name || `${floor.name_en} Archived Relic`, note};
}